import React from 'react';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';

class HiddenInput extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			value: props.value,
		};
	}

	componentWillReceiveProps(props) {
		this.setState({
			value: props.value,
		});
	}

	render() {
		return <input className={'hidden'} name={this.props.name} type="hidden" value={this.state.value || ''} required={this.props.required} />;
	}
}

HiddenInput.propTypes = {
	name: PropTypes.string,
	value: PropTypes.any,
	required: PropTypes.bool,
};

export default withFormsy(HiddenInput);
